import script from "./machinist.vue?vue&type=script&setup=true&lang=js"
export * from "./machinist.vue?vue&type=script&setup=true&lang=js"

import "./machinist.vue?vue&type=style&index=0&id=298ed881&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-298ed881"]])

export default __exports__